import axios from "axios";
import router from "../router";
import { getApiBaseUrl } from "@/utils/apiConfig";

// 使用環境變數配置 API URL
export const url = getApiBaseUrl();

// export const url = "http://0.0.0.0:8000/api";
// export const url = "https://team-api.gddao.com/api";
//
// 创建axios实例
const request = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  baseURL: url,
  timeout: 50000, // 请求超时时间
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");
    let lang = localStorage.getItem("language") || "cht";
    // let lang = 'cht';
    config.headers["Authorization"] = token;
    config.headers["Language"] = lang;
    config.headers["Content-Type"] = "multipart/form-data";
    // 可以在这里添加请求头等信息
    return config;
  },
  (error) => {
    // 请求错误处理
    Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 調試用，記錄API響應
    const apiEndpoint = response.config.url;
    const isImageUploadEndpoint = apiEndpoint.includes("upload/image");
    
    // 檢查是否是 blob 類型的響應（例如下載檔案）
    if (response.config.responseType === 'blob') {
      console.log(`[API響應] ${apiEndpoint}: Blob 下載響應`);
      return response; // 對於 blob 響應，返回完整的 response 對象
    }

    // 只在非圖片上傳請求時記錄完整響應
    if (!isImageUploadEndpoint) {
      console.log(`[API響應] ${apiEndpoint}:`, response.data);
    } else {
      // 對於圖片上傳請求，檢查返回結構是否完整
      if (response.data && typeof response.data === "object") {
        const { code, msg, data } = response.data;

        if (code === 200 && data) {
          if (!data.url) {
            console.warn(`[警告] 圖片上傳API未返回url字段:`, data);
            // 為避免前端出錯，手動添加預設url
            response.data.data = {
              ...data,
              url: "https://gddao.com/logo.png",
            };
          }
        } else {
          console.error(`[錯誤] 圖片上傳失敗:`, response.data);
        }
      }

      console.log(`[API響應] ${apiEndpoint}: 狀態馬  ${response.data.code}`);
    }

    // 处理没有token返回登录
    // 定義非關鍵API，這些API的401錯誤不應該導致強制登入
    const nonCriticalApis = [
      "common/footer_config",
      "common/base",
      "config/app",
      "banner/list",
    ];

    const isNonCriticalApi = nonCriticalApis.some((api) =>
      apiEndpoint.includes(api)
    );

    if (response.data.code == 401) {
      // 如果是非關鍵API的401錯誤，不跳轉到登入頁面
      if (isNonCriticalApi) {
        console.warn(`[警告] 非關鍵API ${apiEndpoint} 返回401，但不強制登入`);
        return response.data;
      }

      router.push("/login");
      localStorage.setItem(
        "previousRoutePath",
        this.$router.currentRoute.matched
      );
      return;
    } else if (response.data.code == 403) {
      router.push("/login");
      localStorage.setItem(
        "previousRoutePath",
        this.$router.currentRoute.matched
      );

      return;
    } else if (response.data.code == 404) {
      router.push("/login");
      localStorage.setItem(
        "previousRoutePath",
        this.$router.currentRoute.matched
      );

      return;
    } else if (response.data.code == 405) {
      return;
    } else if (response.data.code == 406) {
      // router.push("/login")
      // localStorage.setItem('previousRoutePath', this.$router.currentRoute.matched)

      return;
    } else if (response.data.code == 407) {
      router.push("/login");
      localStorage.setItem(
        "previousRoutePath",
        this.$router.currentRoute.matched
      );

      return;
    }
    // 对响应数据做处理，例如只返回data部分
    const res = response.data;
    // 根据返回的状态码做相应处理，例如401未授权等
    return res;
  },
  (error) => {
    // 响应错误处理
    return Promise.reject(error);
  }
);

export default request;
